import Image from "next/image";
import type { CSSProperties } from "react";

import type { SeoWorkflowConnectIntegrationCopy } from "@/components/home/seo-workflow/seo-workflow-copy";

function CheckIcon() {
  return (
    <svg width="10" height="10" viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path
        d="M5 12.5 9.5 17 19 7"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

type CcProductCanvasFrameIntegrationsProps = {
  linkingLabel: string;
  integrations: SeoWorkflowConnectIntegrationCopy[];
  isCrossfadeOut?: boolean;
};

/** Compact integration pills (AI automation workflow connect showcase pattern). */
export function CcProductCanvasFrameIntegrations({
  linkingLabel,
  integrations,
  isCrossfadeOut = false,
}: CcProductCanvasFrameIntegrationsProps) {
  if (integrations.length === 0) return null;

  const className = [
    "cc-product-canvas__frame-integrations",
    isCrossfadeOut ? "is-integrations-crossfade-out" : "",
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <div className={className} aria-hidden="true">
      <span className="cc-product-canvas__frame-integrations-linking">
        <span className="cc-product-canvas__frame-integrations-linking-dot" aria-hidden="true" />
        {linkingLabel}
      </span>
      <ul className="cc-product-canvas__frame-integrations-list">
        {integrations.map((item, index) => (
          <li
            key={item.id}
            className="cc-product-canvas__frame-integration"
            style={{ "--frame-integration-index": index } as CSSProperties}
          >
            {item.logo ? (
              <Image
                className="cc-product-canvas__frame-integration-logo"
                src={item.logo}
                alt=""
                width={16}
                height={16}
                unoptimized
              />
            ) : (
              <span className="cc-product-canvas__frame-integration-fallback">{item.name.charAt(0)}</span>
            )}
            <span className="cc-product-canvas__frame-integration-name">{item.name}</span>
            <span className="cc-product-canvas__frame-integration-status">
              <span className="cc-product-canvas__frame-integration-check" aria-hidden="true">
                <CheckIcon />
              </span>
              {item.status}
            </span>
          </li>
        ))}
      </ul>
    </div>
  );
}
